export default class HelpHand extends Phaser.GameObjects.Image {
  /**
   *  A simple prefab (extended game object class), displaying a spinning
   *  Phaser 3 logo.
   *
   *  @extends Phaser.GameObjects.Image
   */
  constructor (scene, x, y, bg) {
    super(scene, x, y, 'hand');
    scene.add.existing(this);
    this.scene = scene;
    this.offsetX = this.width * 0.35;
    this.offsetY = this.height * 0.35;
    this.x += this.offsetX;
    this.y += this.offsetY;
    this.startScaleX = this.scaleX;
    this.startScaleY = this.scaleY;
    this.startX = this.x;
    this.startY = this.y;
    this.targetX = bg.x;
    this.targetY = bg.y;
    this.bgWidth = bg.width;
    this.bgHeight = bg.height;
    this.emitter = new Phaser.Events.EventEmitter();
    this.resetAnims();
  }

  resetAnims () {
    this.animIndex = 0;
    this.scaleX = 0;
    this.scaleY = 0;
    this.x = this.startX;
    this.y = this.startY;
    if (this.handTween !== undefined) {
      this.handTween.stop();
      this.handTween = undefined;
    }
  }

  setAnims (anims) {
    this.anims = anims;
    this.resetAnims();
  }

  start () {
    this.nextAnim();
  }

  handleAnimComplete () {
    if (this.animIndex >= this.anims.length - 1) {
      this.emitter.emit('stepComplete');
      this.resetAnims();
    } else {
      this.animIndex = (this.animIndex + 1) % this.anims.length;
    }
    this.nextAnim();
  }

  nextAnim () {
    let anim = this.anims[this.animIndex];
    if (this.handTween !== undefined) {
      this.handTween.stop();
      this.handTween = undefined;
    }
    let delay = anim.delay !== undefined ? anim.delay : 0;
    if (anim.type === 'move') {
      this.moveHand(anim.target.x, anim.target.y, anim.time, anim.easing, delay);
    } else if (anim.type === 'tap') {
      this.tapHand(anim.time, anim.easing, delay);
    } else if (anim.type === 'scale') {
      this.scaleHand(anim.scale, anim.scale, anim.time, anim.easing, delay);
    }
  }

  moveHand (x, y, time, easing, d) {
    let actualX = this.targetX + x * this.bgWidth + this.offsetX;
    let actualY = this.targetY - y * this.bgHeight + this.offsetY;
    this.handTween = this.scene.tweens.add({
      targets: this,
      x: actualX,
      y: actualY,
      duration: time,
      ease: easing,
      delay: d,
      onComplete: () => {
        this.handleAnimComplete();
      }
    });
  }

  scaleHand (w, h, time, easing, d) {
    this.handTween = this.scene.tweens.add({
      targets: this,
      scaleX: this.startScaleX * w,
      scaleY: this.startScaleY * h,
      duration: time,
      ease: easing,
      delay: d,
      onComplete: () => {
        this.handleAnimComplete();
      }
    });
  }

  tapHand (time, easing, d) {
    this.handTween = this.scene.tweens.add({
      targets: this,
      scaleX: this.startScaleX * 0.85,
      scaleY: this.startScaleY * 0.85,
      duration: time,
      yoyo: true,
      ease: easing,
      delay: d,
      onComplete: () => {
        this.handleAnimComplete();
      }
    });
  }

  destroy () {
    if (this.handTween !== undefined) {
      this.handTween.stop();
      this.handTween = undefined;
    }
    this.scene = null;
    this.animations = null;
    super.destroy();
  }
}
